export default class ColumnDefinition {
  id;

  label;

  type;

  sortable = false;

  hideable = false;

  defaultHidden = false;

  action;

  sortFunction = (a, b) =>
    this.type === 'number'
      ? this.render(a) - this.render(b)
      : this.render(a)?.toString().localeCompare(this.render(b)?.toString());

  constructor({
    id,
    label,
    type,
    sortable,
    action,
    render,
    sortFunction,
    hideable,
    defaultHidden,
  }) {
    this.id = id;
    this.label = label;
    this.type = type;
    // Optional vars
    if (action) this.action = action;
    if (sortable) this.sortable = sortable;
    if (render) this.render = render;
    if (sortFunction) this.sortFunction = sortFunction;
    if (hideable) this.hideable = hideable;
    if (defaultHidden) this.defaultHidden = defaultHidden;
  }

  // render is used to take a value from the column and make it into a user-friendly string.
  render(value) {
    return this.format && typeof value === 'number' ? this.format(value) : value;
  }
}
